import { useRef } from "react";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { examTrim } from "../../../api/examTrim";
import { useRecoilValue } from "recoil";
import { isPracticeState } from "../../../recoil/record";

const ExamQuestionInfo = ({ questionIndex, questionList, handleRecording }) => {
  const isPractice = useRecoilValue(isPracticeState);
  const [currentQuestion, setCurrentQuestion] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const MAX_QUESTTION_NUMBER = isPractice? 1 : 15;

  useEffect(() => {
    if (questionList) {
      setCurrentQuestion(questionList);
    }
  }, [questionList, questionIndex]);

  // 자동재생이 끝나고 다시 한번만 재생하는 기능
  let timeoutId = null;
  useEffect(() => {
    const audioElement = audioRef.current;

    const handleEnded = () => {
      timeoutId = setTimeout(() => {
        audioElement.play();
        audioElement.removeEventListener("ended", handleEnded);
        clearTimeout(timeoutId);
      }, 5000);
    };

    audioElement.addEventListener("ended", handleEnded);
  }, [questionIndex]);

  return (
    <div className="half-area">
      {questionList.length !== 0 && currentQuestion && (
        <>
          {isMobile && !isPlaying && (
            <>
              <div className="qna" style={{ textAlign: "center" }}>
                <p>
                  휴대폰에서 질문이 자동으로 재생되지 않을 경우, <br /> 아래의
                  버튼을 눌러주세요.
                </p>
                <button
                  className="start-step-btn"
                  onClick={() => {
                    audioRef.current.play();
                    setIsPlaying(true);
                  }}
                >
                  <img
                    style={{ margin: 16 }}
                    width={40}
                    src="img/play_audio.png"
                  />
                </button>
              </div>
            </>
          )}

          <audio
            autoPlay
            ref={audioRef}
            src={`${currentQuestion?.voice_file_url}`}
            onEnded={() => handleRecording()}
          />
          <div className="black-box text-align-center">
            <p>
              질문 {questionIndex} / {MAX_QUESTTION_NUMBER}
            </p>
          </div>
          <div className="exam-question-box">
            <div className="exam-question">
              <span className="question-t">전체문항</span>
              <span className="question-n">{MAX_QUESTTION_NUMBER}</span>
            </div>
            <div className="exam-question">
              <span className="question-t">남은문항</span>
              <span className="question-n">
                {MAX_QUESTTION_NUMBER - questionIndex}
              </span>
            </div>
            <div className="exam-question">
              <span className="question-t">응시종목</span>
              <span className="question-n">
              KHNP 영어 말하기 모의평가
              </span>
            </div>
            <div className="question">
              <p>Q. 질문을 보고 답변하세요.</p>
              <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                {examTrim(currentQuestion?.text)}
              </p>
              <br></br>
              <audio
                ref={audioRef}
                controls="controls"
                style={{
                  width: "100%",
                  verticalAlign: "bottom",
                  position: "absolute",
                  left: "-9999px",
                }}
                src={`${currentQuestion?.voice_url}`}
                autoPlay
              ></audio>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExamQuestionInfo;
